module.exports = __webpack_public_path__ + "static/media/digging.57716e32.svg";